export const DELETE_PROCESS_STATEMENT_COMMENT_SUCCESS = 'DELETE_PROCESS_STATEMENT_COMMENT_SUCCESS';

export const deleteProcessStatementCommentSuccess = (processStatement) => ({
    type: DELETE_PROCESS_STATEMENT_COMMENT_SUCCESS,
    payload: { processStatement },
});
